export default __webpack_public_path__ + "static/hq15-b7532616d692bd499885bf6713b35c16.jpg";